<!--<div class="form-wraper">-->
<!--  <div class="form-container card" style="background: var(&#45;&#45;background);">-->
<!--    <div class="row" style="&#45;&#45;bs-gutter-x: 0">-->
<!--      <div class="col-md-6">-->
<!--        &lt;!&ndash;       <img src="./../../../assets/logo-down.png" style=""  class="main-lock-icon" alt="">&ndash;&gt;-->
<!--        <br><br>-->
<!--        <div style="margin-left: 6vw;">-->
<!--          <div style="opacity: 0.65; font-size: 32px;"><b>Kontakt</b></div>-->
<!--          <br>-->
<!--          <div style="display: flex; align-items: center;">-->
<!--            <mat-icon style="opacity: 0.5; transform: scale(1);" class="non-selectable">call</mat-icon>-->
<!--            <span style="margin-left: 8px; opacity: 0.5; font-size: 20px"><b>{{config['contact_phone']}}</b></span>-->
<!--          </div>-->
<!--          <br>-->
<!--          <div style="opacity: 0.5; font-size: 20px">Godziny pracy infolinii:</div><br>-->
<!--          <div style="opacity: 0.5; font-size: 20px"><b>pon. - pt. 10:00 - 18:00</b></div><br>-->
<!--          <div style="opacity: 0.5; font-size: 20px">Możesz również wysłać do nas wiadomość</div><br>-->
<!--          <div><span style="opacity: 0.5; font-size: 20px">e-mail:</span><b style="margin-left: 8px; font-size: 20px; color: var(&#45;&#45;accent-color)">{{config['contact_email']}}</b></div><br>-->
<!--          <span style="opacity: 0.5; font-size: 20px">lub skorzystać z</span> <b style="margin-left: 8px; font-size: 20px; color: var(&#45;&#45;accent-color)">formularza kontaktowego</b><br>-->
<!--          <br>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-md-6">-->
<!--        <br><br>-->
<!--        <div class="main-lock-icon noselect" style="margin-top: 6px">-->
<!--          <img src="../../../assets/contact.png" style="width: 82%;">-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<!--<div class="header border-top-radius">-->
<!--  <div class="try-now-container">-->
<!--    <h2 class="try-now-description">Bezpieczeństwo</h2>-->
<!--  </div>-->
<!--</div>-->

<div class="row demo border-bottom-radius" style="background: var(--background)">
  <div class="col-sm-12 col-xl-5 demo-data margin-right-if-scaled margins">

    <div class="width-100" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">

      <div style="display: flex; flex-direction: row; align-items: center">
        <div style="">
          <!--            <mat-icon class="icons"-->
          <!--              style="background-color: rgba(33, 150, 243, 0.15); color: #01a8a5;">-->
          <mat-icon class="icons noselect"
                    style="background-color: rgba(1, 146, 103, 0.15); color: #019267;">
            phone
          </mat-icon>
        </div>
        <h1 class="demo-title"
            style="margin-bottom: 0; margin-left: 12px;">{{ 'title' | language:'contact':languageService.selectedLanguage }}
        </h1>
      </div>

    </div>
    <!-- -->
    <div class="width-100" style="font-size: 2rem; display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
    <b>{{config.contact_company_name}}</b>
    </div>

    <div class="width-100" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
      {{ 'nip' | language:'contact':languageService.selectedLanguage }}
    : {{config.contact_company_vat}}
    <br>
    {{config.contact_company_adress_line_0}},
    {{config.contact_company_adress_line_2}},
    {{config.contact_company_adress_country}}
    </div>
    <!-- -->
    <div class="width-100"
         style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">

      <div>
        <a class="contact" style=""
           [href]="'tel:'+ config.contact_phone.replace(' ', '').replace(' ', '').replace(' ', '')">
          <div style="height: 24px;" [title]="config.contact_phone">
            <mat-icon class="contact-icon" style="margin-right: 6px;">phone</mat-icon>
          </div>
          <div class="contact-phone">{{config.contact_phone}}</div>
        </a>
      </div>

    </div>

    <div class="demo-data" style="padding-top: 0;">

      <span style="margin-bottom: 20px;">
      <h3 class="demo-description">
        <div>{{ 'first paragraph' | language:'contact':languageService.selectedLanguage }}
        </div>
      </h3>
      <h3 class="demo-description">
        {{ 'second paragraph' | language:'contact':languageService.selectedLanguage }} <b style="color: var(--accent-color); margin-left: 12px;font-weight: 400"> {{ 'second paragraph hours' | language:'contact':languageService.selectedLanguage }}</b>
      </h3>

      <h3 class="demo-description">
        {{ 'third paragraph' | language:'contact':languageService.selectedLanguage }} <b style="color: var(--accent-color); margin-left: 12px;font-weight: 400"> {{ 'third paragraph hours' | language:'contact':languageService.selectedLanguage }}</b>
      </h3>
      </span>

      <span style="margin-bottom: 20px;">
      <h3 class="demo-description">
        <div>{{ 'fourth paragraph' | language:'contact':languageService.selectedLanguage }}</div>
      </h3>
      <a class="contact" [href]="'mailto:'+ config.contact_email">
        <div style="height: 24px;" [title]="config.contact_email">
          <mat-icon class="contact-icon" style="margin-right: 6px;">email</mat-icon>
        </div>
        <div class="contact-email">{{config.contact_email}}</div>
      </a>
      </span>

    </div>

    <div class="demo-buttons">
      <a routerLink="/o-nas" class="not-underline">
        <button mat-button class="demo-button">
          <b>{{ 'first button' | language:'contact':languageService.selectedLanguage }}</b></button>
      </a>
      <a routerLink="/" class="not-underline">
        <button mat-button class="demo-button-2">
          <b>{{ 'second button' | language:'contact':languageService.selectedLanguage }}</b></button>
      </a>
    </div>
  </div>

  <div class="col-sm-12 col-xl-5 demo-movie noselect">
    <img class="image-scaler" src="./assets/vector/sibrica-it-projects-contact.jpg"
         [alt]="'image alt' | language:'contact':languageService.selectedLanguage" width="600" height="400"
         style="align-content: center; border-radius: 16px;">
         <!-- style="max-width: 90vw; max-height: calc(70vw / 400 * 465); border-radius: 16px;"> -->
    <!--    <img class="image-scaler" width="500" style="max-width: 90vw; border-radius: 16px;" src="https://image.shutterstock.com/image-photo/colleagues-working-on-agile-product-260nw-1376317913.jpg">-->
    <!--    <iframe style="max-width: 90vw; max-height: calc(90vw * 315 / 560)" src="https://www.youtube.com/embed/QH2-TGUlwu4" width="560" height="315" frameborder="0"></iframe>-->
  </div>

</div>

